module.exports = __webpack_public_path__ + "img/showcase-storefront.d6ea37cf.png";